// Imports
var ___HTML_LOADER_IMPORT_0___ = new URL("../../assets/images/navigation/close-popup.svg", import.meta.url);
// Module
var code = `<nav id="mainNavigation"
	class="navigation"
	ng-class="{'navigation--sticky': \$ctrl.isSticky}">
	<div class="navigation__inner">
		<div class="container container--gap d-flex justify-content-between align-items-center">

			<!-- Logo -->
			<div class="navigation__logo d-none d-lg-block">
				<a ng-href="/">
					<img ng-src="{{\$ctrl.isSticky ? \$ctrl.logo.sticky : \$ctrl.logo.default}}"
						alt="{{\$ctrl.logo.alt}}"
						class="navigation__logo-image" />
				</a>
			</div>


			<div class="navigation__logo d-block d-lg-none">
				<a ng-href="/">
					<img ng-src="{{\$ctrl.logo.sticky}}"
						alt="{{\$ctrl.logo.alt}}"
						class="navigation__logo-image" />
				</a>
			</div>




			<div class="navigation__mobile navigation__mobile--desktop d-none d-lg-block mr-auto">
				<div class="navigation__mobile-inner">

					<ul class="navigation__list navigation__list--mobile">
						<li ng-class="{'navigation__item--active': \$index === 0}"
							class="navigation__item"
							ng-repeat="item in \$ctrl.menu">

							<!-- LINK PRINCIPAL -->
							<a href="{{item.subMenu ? '#' : item.url}}"
								class="navigation__link"
								ng-class="{'dropdown-toggle': item.subMenu}"
								role="{{item.subMenu ? 'button' : undefined}}"
								data-toggle="{{item.subMenu ? 'dropdown' : undefined}}"
								aria-haspopup="{{item.subMenu ? 'true' : undefined}}"
								aria-expanded="false"
								ng-click="item.subMenu && \$event.preventDefault()">

								{{item.label}}
							</a>

							<!-- SUBMENU -->
							<ul class="navigation__submenu dropdown-menu"
								ng-if="item.subMenu">
								<li class="navigation__submenu-item"
									ng-repeat="sub in item.subMenu">
									<a class="dropdown-item"
										href="{{sub.url}}">
										{{sub.label}}
									</a>
								</li>
							</ul>

						</li>
					</ul>

				</div>


			</div>

			<a class="navigation__popup-cta link-global d-none d-lg-block link-global--white"
				target="_blank"
				rel="noopener noreferrer"
				ng-href="{{\$ctrl.popUp.link}}">
				{{\$ctrl.popUp.CTA}}
			</a>

			<!-- Hamburger Button (solo en móviles) -->
			<div class="navigation__actions d-lg-none">
				<button class="navigation__hamburger btn"
					type="button"
					ng-click="\$ctrl.toggleMenu()">
					<img ng-src="{{\$ctrl.isMenuOpen ? \$ctrl.closeIcon : \$ctrl.hamburgerIcon}}"
						alt="{{\$ctrl.isMenuOpen ? 'Cerrar menú' : 'Abrir menú'}}"
						class="navigation__hamburger-icon" />
				</button>
			</div>

		</div>
	</div>


	<!-- Pop-up de navegación (solo móviles) -->
	<div class="navigation__popup d-none"
		ng-if="\$ctrl.isPopUpOpen">
		<div class="navigation__popup-inner container d-flex justify-content-between align-items-center">

			<button type="button"
				ng-click="\$ctrl.closePopUp()"
				class="btn navigation__popup-close">
				<img src="${___HTML_LOADER_IMPORT_0___}"
					alt="">
			</button>


			<div class="navigation__popup-item d-flex  align-items-center">
				<img class="navigation__popup-icon"
					ng-src="{{\$ctrl.popUp.icon.src}}"
					ng-alt="{{\$ctrl.popUp.icon.alt}}">
				<div class="navigation__popup-description"
					ng-bind-html="\$ctrl.popUp.description">
				</div>
			</div>

			<a class="navigation__popup-cta link-global"
				target="_blank"
				rel="noopener noreferrer"
				ng-href="{{\$ctrl.popUp.link}}">
				{{\$ctrl.popUp.CTA}}
			</a>

		</div>
	</div>

	<div id="navigationMobile"
		class="navigation__mobile d-lg-none">
		<div class="navigation__mobile-inner">

			<ul class="navigation__list navigation__list--mobile">
				<li ng-class="{'navigation__item--active': \$index === 0}"
					class="navigation__item"
					ng-repeat="item in \$ctrl.menu">

					<!-- LINK PRINCIPAL -->
					<a href="{{item.subMenu ? '#' : item.url}}"
						class="navigation__link"
						ng-class="{'dropdown-toggle': item.subMenu}"
						role="{{item.subMenu ? 'button' : undefined}}"
						data-toggle="{{item.subMenu ? 'dropdown' : undefined}}"
						aria-haspopup="{{item.subMenu ? 'true' : undefined}}"
						aria-expanded="false"
						ng-click="item.subMenu && \$event.preventDefault()">

						{{item.label}}
					</a>

					<!-- SUBMENU -->
					<ul class="navigation__submenu dropdown-menu"
						ng-if="item.subMenu">
						<li class="navigation__submenu-item"
							ng-repeat="sub in item.subMenu">
							<a class="dropdown-item"
								href="{{sub.url}}">
								{{sub.label}}
							</a>
						</li>
					</ul>

				</li>
			</ul>

			<div class="navigation__slide">
				<div class="container">
					<h4 class="navigation__slide-title">Te recomendamos</h4>
					<div class="navigation__owl owl-carousel">
						<div class="navigation__owl-item"
							ng-repeat="slide in \$ctrl.slideRec">
							<img ng-src="{{slide.image}}"
								alt="{{slide.alt}}">
						</div>
					</div>
				</div>
			</div>

			<div class="navigation__mobile-actions">
				<div class="container navigation__mobile-actions-item d-flex align-items-center justify-content-center">
					<a ng-repeat="action in \$ctrl.mobileActions"
						ng-href="{{action.url}}"
						class="link-global link-global--lg"
						ng-class="{
				'link-global--purple': action.color === 'morado'
			}">

						<img ng-if="action.icon"
							ng-src="{{action.icon}}"
							alt=""
							class="navigation__mobile-action-icon">

						{{action.label}}
					</a>
				</div>
			</div>

		</div>


	</div>

</nav>`;
// Exports
export default code;